import React, { useState } from 'react';
import { Card, CardBody, TabContent, TabPane } from 'reactstrap';
import ErrorBoundary from 'components/common/ErrorBoundary';
import Heading from 'components/Heading';
import CustomTabs from 'components/CustomTabs';
import CouponSearch from './components/CouponSearch';
import { couponConstants } from './constants';

const OfferCoupons = () => {
  const [activeTab, setActiveTab] = useState(couponConstants.ALL);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="coupon-page">
      <div className="mb-3 pb-1 top-head">
        <Heading title="Coupons" />
      </div>
      <ErrorBoundary>
        <Card className="border-0 card-box page-card-box ">
          <CardBody>
            <CustomTabs
              tabs={[
                couponConstants.ALL,
                couponConstants.INACTIVE,
                couponConstants.DELETED,
                couponConstants.EXPIRED,
              ]}
              selectedTab={activeTab}
              onTabChange={toggle}
            />
            <TabContent activeTab={activeTab}>
              {activeTab === couponConstants.ALL && (
                <TabPane tabId={couponConstants.ALL}>
                  <CouponSearch tabType={couponConstants.ALL} />
                </TabPane>
              )}
              {activeTab === couponConstants.INACTIVE && (
                <TabPane tabId={couponConstants.INACTIVE}>
                  <CouponSearch tabType={couponConstants.INACTIVE} />
                </TabPane>
              )}
              {activeTab === couponConstants.DELETED && (
                <TabPane tabId={couponConstants.DELETED}>
                  <CouponSearch tabType={couponConstants.DELETED} />
                </TabPane>
              )}
              {activeTab === couponConstants.EXPIRED && (
                <TabPane tabId={couponConstants.EXPIRED}>
                  <CouponSearch tabType={couponConstants.EXPIRED} />
                </TabPane>
              )}
            </TabContent>
          </CardBody>
        </Card>
      </ErrorBoundary>
    </div>
  );
};

export default OfferCoupons;
